module.exports = __webpack_public_path__ + "img/mcdonalds.591efa7e.jpg";